import React from 'react'
import {KsLogo} from '../../../components/icons'
import {Box, Image} from '@chakra-ui/react'
import {getUrl} from '../../../utils/cloudinary-utils'
const CbMobileSpinner = () => {
    return (
        <Box gap="48px" display={{base: 'grid', lg: 'none'}} margin="60px">
            <Image
                src={getUrl('UIImages/images/colorbar-by-ks.svg')}
                maxWidth="321px"
                margin="auto"
                width="100%"
                height="55px"
                alt="Color Bar by Kendra Scott"
            />
            <Box
                sx={{
                    display: 'inline-block',
                    transformOrigin: '50% 50%',
                    width: '75px',
                    height: '75px',
                    margin: 'auto',
                    animation: 'dingDongMobile 3.65s ease-in-out infinite' // slowed down
                }}
            >
                <KsLogo width="75px" height="75px" alt="Kendra Scott Logo" />
                <style>
                    {`
                    @keyframes dingDongMobile {
                        0%   { transform: rotate(0deg); }
                        50%  { transform: rotate(179deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
                </style>
            </Box>
            <Image
                src={getUrl('UIImages/images/colorbar-stage-mobile.svg')}
                maxWidth="309px"
                margin="auto"
                width="309px"
                height="257px"
                alt="Color Bar Stage"
            />
        </Box>
    )
}

export default CbMobileSpinner
